import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputSelectSF from '../../../widgets/form/InputSelectSF'
import InputTextAreaSF from '../../../widgets/form/InputTextAreaSF'
import InputDateUI from '../../../widgets/form/InputDateUI'
import InputDateTimeUI from '../../../widgets/form/InputDateTimeUI'
import InputTimeUI from '../../../widgets/form/InputTimeUI'
import MultiDateInputUI from '../../../widgets/form/MultiDateInputUI'

const PropertyUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  // superuser role
  propertyValue, onPropertyValueChange, propertyValueError, setPropertyValueError,
  propertyType, propertySelectListBool, selectedProperty
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update property'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    {
      propertyType && propertyType !== 'textarea' && propertyType !== 'value_set' && propertyType !== 'boolean_' && propertyType !== 'date' && propertyType !== 'datetime' && propertyType !== 'time' && propertyType !== 'minutes' &&
      <InputTextSF type='text' name='propertyValue' label='Property value'
        required={true} maxLength={500} autoFocus={true}
        value={propertyValue} onChange={onPropertyValueChange}
        error={propertyValueError} setError={setPropertyValueError}
      />
    }
    {
      propertyType === 'textarea' &&
      <InputTextAreaSF type='text' name='propertyValue' label={selectedProperty.propertyName}
        required={true} rows="5" maxLength={1000} autoFocus={true}
        value={propertyValue} onChange={onPropertyValueChange}
        error={propertyValueError} setError={setPropertyValueError}
        help={`${selectedProperty.hint ? selectedProperty.hint : ''} ${selectedProperty.defaultValue ? ('Default: ' + selectedProperty.defaultValue) : ''}`}
      />
    }
    {/*
      propertyType === 'value_set' &&
      <InputSelectSF type='select' name='propertyValue' label={selectedProperty.propertyName}
        value={propertyValue} onChange={onPropertyValueChange} optionList={propertySelectList}
        error={propertyValueError} setError={setPropertyValueError}
        help={`${selectedProperty.hint ? selectedProperty.hint : ''} ${selectedProperty.defaultValue ? ('Default: ' + selectedProperty.defaultValue) : ''}`}
      />
    */}
    {
      propertyType === 'boolean_' &&
      <InputSelectSF type='select' name='propertyValue' label={selectedProperty.propertyName}
        value={propertyValue} onChange={onPropertyValueChange} optionList={propertySelectListBool}
        error={propertyValueError} setError={setPropertyValueError}
      />
    }
    {
      propertyType === 'date' && selectedProperty.propertyCode === 'national_holidays' &&
      <MultiDateInputUI
        context={context}
        label={selectedProperty.propertyName}
        help={selectedProperty.hint}
        value={propertyValue}
        onChange={onPropertyValueChange}
        error={propertyValueError}
      />
    }
    {
      propertyType === 'date' && selectedProperty.propertyCode !== 'national_holidays' &&
      <InputDateUI
        context={context}
        name='propertyValue'
        label={selectedProperty.propertyName}
        selectedDateISO={propertyValue}
        onChange={(iso) => onPropertyValueChange({ target: { value: iso || '' } })}
        error={propertyValueError}
      />
    }
    {
      propertyType === 'datetime' &&
      <InputDateTimeUI
        context={context}
        name='propertyValue'
        label={selectedProperty.propertyName}
        selectedDateISO={propertyValue}
        onChange={(iso) => onPropertyValueChange({ target: { value: iso || '' } })}
        error={propertyValueError}
      />
    }
    {
      propertyType === 'minutes' &&
      <InputTimeUI
        context={context}
        name='propertyValue'
        label='Property value'
        selectedDateISO={propertyValue}
        startTime={'18:15'}
        endTime={'23:00'}
        placeholder='Select time'
        onChange={(time) => onPropertyValueChange({ target: { value: time || '' } })}
        error={propertyValueError}
      />
    }
  </ModalFormUI>

export default PropertyUpdateModalUI
